var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIconLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1 25.7h3.8v3.8h-3.8v-3.8Zm0-15.2h3.8v11.4h-3.8V10.5ZM19.981 1C9.493 1 1 9.512 1 20s8.493 19 18.981 19C30.488 39 39 30.488 39 20S30.488 1 19.981 1ZM20 35.2c-8.398 0-15.2-6.802-15.2-15.2S11.602 4.8 20 4.8 35.2 11.602 35.2 20 28.398 35.2 20 35.2Z",
    fill: "#DA291C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconLarge);
export default __webpack_public_path__ + "static/media/ErrorIconLarge.0026fcda832e749a523f5e89d8a15e33.svg";
export { ForwardRef as ReactComponent };